// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import { useNavigate } from "react-router-dom";
// import useApi from "../../../CustomHooks/useApi";
// import { useSelector } from "react-redux";

// const Settlement2Remitter = () => {
//     const location = useLocation();
//     const remitter_mobile = location.state?.mobile;

//     const onetimelimit = useSelector((store) => store?.auth?.employeeDetails?.oneTimeLimit);
//     const navigate = useNavigate();

//     const username = useSelector((state) => state.auth.employeeDetails?.username);

//     const [beneficiaries, setBeneficiaries] = useState([]);
//     const [beneid, setBeniId] = useState("");
//     const [selectedModes, setSelectedModes] = useState({});
//     const [amounts, setAmounts] = useState({});
//     const [error, setError] = useState("");
//     const [selectedRows, setSelectedRows] = useState([]);
//     const [selectedCheckbox, setSelectedCheckbox] = useState(null);
//     const [loading, setLoading] = useState(false);
//     const [showDeletePopup, setShowDeletePopup] = useState(false);
//     const [deleteLoading, setDeleteLoading] = useState(false);
//     const [customerDetails, setCustomerDetails] = useState(null);

//     // ── Search state ───────────────────────────────────────────────────────────
//     const [searchQuery, setSearchQuery] = useState("");

//     const { callApi: fetchBeneIMPS1 } = useApi("/dmt/list/beneficiary", "GET");
//     const { callApi: fetchCustomerDetails } = useApi(
//         "/payout/customer/details",
//         "GET"
//     );
//     const { callApi: deletebene } = useApi("/dmt/delete/beneficiary", "PUT");

//     useEffect(() => {
//         if (remitter_mobile) {
//             fetchBeneficiaries();
//             getCustomerDetails();
//         }
//     }, [remitter_mobile]);

//     const hasValidAmount = (index) => {
//         const val = amounts[index];
//         return val && Number(val) >= 1000;
//     };

//     useEffect(() => {
//         if (beneficiaries.length > 0) {
//             const defaultModes = {};
//             beneficiaries.forEach((_, index) => {
//                 defaultModes[index] = "IMPS";
//             });
//             setSelectedModes(defaultModes);
//         }
//     }, [beneficiaries]);

//     const getCustomerDetails = async () => {
//         try {
//             const res = await fetchCustomerDetails(null, `?mobile=${remitter_mobile}`);
//             setCustomerDetails(res);
//         } catch (err) {
//             console.error("CUSTOMER DETAILS ERROR", err);
//         }
//     };

//     const handleCheckboxChange = (index) => {
//         setError("");

//         if (index === selectedCheckbox) {
//             setSelectedCheckbox(null);
//             setAmounts((prev) => ({ ...prev, [index]: "" }));
//             setSelectedModes((prev) => ({ ...prev, [index]: "" }));
//             setSelectedRows([]);
//             return;
//         }

//         setSelectedCheckbox(index);
//         setSelectedModes((prev) => ({ ...prev, [index]: "IMPS" }));
//         setSelectedRows([
//             {
//                 index,
//                 ...beneficiaries[index],
//                 amount: amounts[index] || "",
//                 mode: "IMPS",
//             },
//         ]);
//     };

//     const handleDeleteBeneficiary = async () => {
//         if (selectedCheckbox === null) return;

//         setDeleteLoading(true);
//         setError("");

//         try {
//             const selectedBeneficiary = beneficiaries[selectedCheckbox];

//             const response = await deletebene(
//                 null,
//                 `?beneficiary_id=${selectedBeneficiary.bene_id || selectedBeneficiary.beneficiaryId}&remitter_mobile=${remitter_mobile}&username=${username}`
//             );

//             console.log("DELETE RESPONSE", response);

//             if (response && response.status !== "FAILED") {
//                 setSelectedCheckbox(null);
//                 setSelectedRows([]);
//                 setAmounts({});
//                 setSelectedModes({});
//                 setShowDeletePopup(false);
//                 await fetchBeneficiaries();
//             } else {
//                 throw new Error("Delete failed");
//             }
//         } catch (error) {
//             console.error("Delete beneficiary failed:", error);
//             setError("Something went wrong while deleting. Please try again.");
//         } finally {
//             setDeleteLoading(false);
//         }
//     };

//     const handleDeleteClick = (beniid) => {
//         if (selectedCheckbox !== null) {
//             setBeniId(beniid);
//             setShowDeletePopup(true);
//         }
//     };

//     const handleCancelDelete = () => {
//         setShowDeletePopup(false);
//     };

//     const handleModeChange = (index, mode) => {
//         setSelectedModes((prev) => {
//             const updatedModes = { ...prev, [index]: mode };
//             if (index === selectedCheckbox) {
//                 setSelectedRows([
//                     {
//                         index,
//                         ...beneficiaries[index],
//                         amount: amounts[index] || "",
//                         mode: mode,
//                     },
//                 ]);
//             }
//             return updatedModes;
//         });
//     };

//     const handleAmountChange = (index, value) => {
//         if (parseFloat(value) < 1000) {
//             setError("Please enter an amount greater than or equal to 1000.");
//         } else {
//             setError("");
//         }

//         if (parseFloat(value) > onetimelimit) {
//             setError(`Please enter an amount less than or equal to ${onetimelimit}`);
//         } else {
//             setError("");
//         }

//         setAmounts((prev) => {
//             const updatedAmounts = { ...prev, [index]: value };
//             if (index === selectedCheckbox) {
//                 setSelectedRows([
//                     {
//                         index,
//                         ...beneficiaries[index],
//                         amount: value,
//                         mode: selectedModes[index] || "",
//                     },
//                 ]);
//             }
//             return updatedAmounts;
//         });
//     };

//     const fetchBeneficiaries = async () => {
//         setLoading(true);
//         try {
//             const response = await fetchBeneIMPS1(null, `?remitter_mobile=${remitter_mobile}`);
//             setBeneficiaries(Array.isArray(response) ? response : []);
//         } catch (error) {
//             console.error("Fetch beneficiaries failed:", error);
//             setBeneficiaries([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const handleAddNewClick = () => {
//         navigate("/add-beneficiary-imps2", {
//             state: {
//                 mobile: customerDetails.mobile,
//                 name: customerDetails.name,
//             },
//         });
//     };

//     const handleProcess = async () => {
//         if (selectedCheckbox === null) {
//             setError("Please select a beneficiary first!");
//             return;
//         }

//         const selectedMode = selectedModes[selectedCheckbox];
//         const selectedAmount = amounts[selectedCheckbox];

//         if (!selectedAmount) {
//             setError("Please enter an amount before proceeding.");
//             return;
//         }

//         if (parseFloat(selectedAmount) > onetimelimit) {
//             setError(`Please enter an amount less than or equal to ${onetimelimit}`);
//             return;
//         }
//         if (parseFloat(selectedAmount) < 1000) {
//             setError("Amount must be at least 1000.");
//             return;
//         }

//         if (!selectedMode) {
//             setError("Please select a mode before proceeding.");
//             return;
//         }

//         setError("");
//         navigate("/settlement1fundtransfer", {
//             state: {
//                 selectedBeneficiary: selectedRows.map(row => ({
//                     ...row,
//                     bene_id: row.bene_id,
//                 })),
//                 amount: selectedAmount,
//             },
//         });
//     };

//     const getStatusClasses = (status) => {
//         switch (status) {
//             case "APPROVED": return "bg-green-100 text-green-600";
//             case "Failed":   return "bg-red-100 text-red-600";
//             case "Pending":  return "bg-yellow-100 text-yellow-600";
//             default:         return "";
//         }
//     };

//     // ── Filtered list (preserves original index for all handlers) ──────────────
//     const filteredList = beneficiaries
//         .map((item, index) => ({ ...item, _originalIndex: index }))
//         .filter((item) => {
//             if (!searchQuery.trim()) return true;
//             const q = searchQuery.toLowerCase();
//             return (
//                 (item.beneficiaryName || "").toLowerCase().includes(q) ||
//                 (item.bankName || "").toLowerCase().includes(q) ||
//                 (item.accountNo || "").toLowerCase().includes(q)
//             );
//         });

//     return (
//         <>
//             <div className="max-w-[100%] mx-auto space-y-4">

//                 {/* ===== HEADER ===== */}
//                 <div className="flex flex-wrap items-center justify-between gap-3 bg-white rounded-2xl px-4 sm:px-6 py-4 shadow-sm border border-slate-200">
//                     {/* Customer info */}
//                     <div className="flex items-center gap-3">
//                         <div className="w-10 h-10 rounded-full bg-[#12345A] flex items-center justify-center text-white font-bold text-sm shrink-0">
//                             {customerDetails?.name?.[0]?.toUpperCase() || "?"}
//                         </div>
//                         <div>
//                             <p className="font-bold text-slate-800 text-base leading-tight">{customerDetails?.name || "—"}</p>
//                             <p className="text-indigo-600 text-sm font-medium">{customerDetails?.mobile || "—"}</p>
//                         </div>
//                     </div>

//                     {/* Right: Search + Add Beneficiary */}
//                     <div className="flex flex-wrap items-center gap-3">
//                         {/* Search input */}
//                         <div className="relative">
//                             <svg
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400 pointer-events-none"
//                                 viewBox="0 0 24 24" fill="none" stroke="currentColor"
//                                 strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
//                             >
//                                 <circle cx="11" cy="11" r="8" />
//                                 <path d="m21 21-4.35-4.35" />
//                             </svg>
//                             <input
//                                 type="text"
//                                 placeholder="Search name, bank, account…"
//                                 value={searchQuery}
//                                 onChange={(e) => setSearchQuery(e.target.value)}
//                                 className="pl-9 pr-8 py-2 text-sm border border-slate-200 rounded-xl bg-slate-50 focus:outline-none focus:border-[#12345A] focus:ring-2 focus:ring-[#12345A]/10 transition w-52 sm:w-64"
//                             />
//                             {searchQuery && (
//                                 <button
//                                     onClick={() => setSearchQuery("")}
//                                     className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 text-lg leading-none transition"
//                                     title="Clear search"
//                                 >
//                                     ×
//                                 </button>
//                             )}
//                         </div>

//                         {/* Add Beneficiary */}
//                         <button
//                             onClick={handleAddNewClick}
//                             className="px-4 py-2 text-sm font-semibold bg-[#12345A] hover:bg-[#0F2E47] text-white rounded-xl shadow transition whitespace-nowrap"
//                         >
//                             + Add Beneficiary
//                         </button>
//                     </div>
//                 </div>

//                 {/* ===== ERROR ===== */}
//                 {error && (
//                     <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm px-4 py-3 rounded-xl">
//                         {error}
//                     </div>
//                 )}

//                 {/* ===== TABLE ===== */}
//                 {loading ? (
//                     <div className="bg-white rounded-2xl p-10 text-center text-slate-500 text-sm shadow-sm border border-slate-200">
//                         Loading beneficiaries…
//                     </div>
//                 ) : beneficiaries.length === 0 ? (
//                     <div className="bg-white rounded-2xl p-10 text-center text-slate-500 text-sm shadow-sm border border-slate-200">
//                         No beneficiaries found
//                     </div>
//                 ) : (
//                     <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
//                         {/* Search result count */}
//                         {searchQuery.trim() && (
//                             <div className="px-4 py-2 text-xs text-slate-500 bg-slate-50 border-b border-slate-100">
//                                 {filteredList.length} of {beneficiaries.length} beneficiar{beneficiaries.length === 1 ? "y" : "ies"} match "<span className="font-semibold text-slate-700">{searchQuery}</span>"
//                             </div>
//                         )}

//                         <div className="overflow-x-auto">
//                             <table className="w-full text-sm border-collapse">
//                                 <thead className="bg-slate-100 text-slate-600 text-xs uppercase tracking-wide">
//                                     <tr>
//                                         <th className="px-3 py-3 text-center w-12 border border-slate-200">Select</th>
//                                         <th className="px-4 py-3 text-left border border-slate-200">Beneficiary</th>
//                                         <th className="px-4 py-3 text-left border border-slate-200">Bank</th>
//                                         <th className="px-4 py-3 text-left border border-slate-200">Account No</th>
//                                         <th className="px-4 py-3 text-left border border-slate-200">IFSC</th>
//                                         <th className="px-4 py-3 text-left border border-slate-200" style={{ minWidth: 200 }}>Amount (₹)</th>
//                                         <th className="px-4 py-3 text-center border border-slate-200" style={{ minWidth: 140 }}>Actions</th>
//                                     </tr>
//                                 </thead>

//                                 <tbody>
//                                     {filteredList.length === 0 ? (
//                                         <tr>
//                                             <td colSpan="7" className="py-12 text-center text-slate-400 border border-slate-200">
//                                                 No results for "<span className="font-semibold">{searchQuery}</span>"
//                                             </td>
//                                         </tr>
//                                     ) : (
//                                         filteredList.map((item) => {
//                                             const index = item._originalIndex;
//                                             const isSelected = selectedCheckbox === index;
//                                             const canTransfer = isSelected && hasValidAmount(index);

//                                             return (
//                                                 <tr
//                                                     key={index}
//                                                     onClick={() => handleCheckboxChange(index)}
//                                                     className={`cursor-pointer transition-colors ${
//                                                         isSelected
//                                                             ? "bg-blue-50/60"
//                                                             : "hover:bg-slate-50"
//                                                     }`}
//                                                 >
//                                                     {/* Select */}
//                                                     <td className="px-3 py-4 text-center border border-slate-200" onClick={(e) => e.stopPropagation()}>
//                                                         <input
//                                                             type="checkbox"
//                                                             checked={isSelected}
//                                                             onChange={() => handleCheckboxChange(index)}
//                                                             className="w-4 h-4 cursor-pointer accent-[#12345A]"
//                                                         />
//                                                     </td>

//                                                     {/* Beneficiary Name + Status */}
//                                                     <td className="px-4 py-4 border border-slate-200">
//                                                         <p className={`font-bold text-sm leading-snug ${isSelected ? "text-[#12345A]" : "text-slate-800"}`}>
//                                                             {item.beneficiaryName}
//                                                         </p>
//                                                         <span className={`inline-block mt-1 px-2 py-0.5 rounded-full text-[10px] font-semibold ${
//                                                             item.verificationStatus === "APPROVED"
//                                                                 ? "bg-emerald-100 text-emerald-700"
//                                                                 : item.verificationStatus === "Pending"
//                                                                     ? "bg-amber-100 text-amber-700"
//                                                                     : "bg-rose-100 text-rose-700"
//                                                         }`}>
//                                                             {item.verificationStatus}
//                                                         </span>
//                                                     </td>

//                                                     {/* Bank */}
//                                                     <td className="px-4 py-4 border border-slate-200">
//                                                         <p className="text-slate-600 text-sm">{item.bankName}</p>
//                                                         <span className="inline-block mt-1 px-1.5 py-0.5 rounded-full text-[10px] font-bold bg-indigo-100 text-indigo-700 tracking-wide">
//                                                             IMPS
//                                                         </span>
//                                                     </td>

//                                                     {/* Account No */}
//                                                     <td className="px-4 py-4 border border-slate-200 font-bold text-red-600 font-mono">
//                                                         {item.accountNo}
//                                                     </td>

//                                                     {/* IFSC */}
//                                                     <td className="px-4 py-4 border border-slate-200 font-black text-slate-900 font-mono">
//                                                         {item.ifscCode}
//                                                     </td>

//                                                     {/* Amount Input */}
//                                                     <td className="px-4 py-4 border border-slate-200" onClick={(e) => e.stopPropagation()}>
//                                                         <input
//                                                             type="text"
//                                                             inputMode="numeric"
//                                                             placeholder="Min ₹1,001"
//                                                             value={amounts[index] || ""}
//                                                             disabled={!isSelected}
//                                                             onChange={(e) => {
//                                                                 const val = e.target.value;
//                                                                 if (/^\d{0,6}$/.test(val)) handleAmountChange(index, val);
//                                                             }}
//                                                             onKeyDown={(e) => {
//                                                                 if (e.key === "Enter" && canTransfer) handleProcess();
//                                                             }}
//                                                             className={`w-full px-3 py-2.5 rounded-xl border text-sm font-semibold outline-none transition ${
//                                                                 isSelected
//                                                                     ? "border-[#12345A] bg-white text-slate-800 focus:ring-2 focus:ring-[#12345A]/20"
//                                                                     : "border-slate-200 bg-slate-50 text-slate-400 cursor-not-allowed"
//                                                             }`}
//                                                         />
//                                                     </td>

//                                                     {/* Actions */}
//                                                     <td className="px-4 py-4 border border-slate-200" onClick={(e) => e.stopPropagation()}>
//                                                         <div className="flex items-center justify-center gap-2">
//                                                             {/* Fund Transfer */}
//                                                             <button
//                                                                 onClick={handleProcess}
//                                                                 disabled={!canTransfer}
//                                                                 title="Fund Transfer"
//                                                                 className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-bold transition whitespace-nowrap ${
//                                                                     canTransfer
//                                                                         ? "bg-[#12345A] text-white shadow-sm hover:bg-[#0F2E47]"
//                                                                         : "bg-slate-100 text-slate-400 cursor-not-allowed"
//                                                                 }`}
//                                                             >
//                                                                 <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
//                                                                     <path d="M5 12h14M12 5l7 7-7 7" />
//                                                                 </svg>
//                                                                 Transfer
//                                                             </button>

//                                                             {/* Delete */}
//                                                             <button
//                                                                 onClick={() => handleDeleteClick(item.bene_id || item.beneficiaryId)}
//                                                                 disabled={!isSelected}
//                                                                 title="Delete Beneficiary"
//                                                                 className={`flex items-center justify-center w-9 h-9 rounded-xl transition ${
//                                                                     isSelected
//                                                                         ? "bg-rose-50 text-rose-600 hover:bg-rose-100 border border-rose-200"
//                                                                         : "bg-slate-100 text-slate-300 cursor-not-allowed border border-slate-200"
//                                                                 }`}
//                                                             >
//                                                                 <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                                                     <polyline points="3 6 5 6 21 6" />
//                                                                     <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
//                                                                     <path d="M10 11v6M14 11v6" />
//                                                                     <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
//                                                                 </svg>
//                                                             </button>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             );
//                                         })
//                                     )}
//                                 </tbody>
//                             </table>
//                         </div>
//                     </div>
//                 )}
//             </div>

//             {/* ===== DELETE CONFIRMATION POPUP ===== */}
//             {showDeletePopup && (
//                 <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//                     <div className="bg-white rounded-2xl p-6 w-full max-w-sm shadow-xl">
//                         <div className="w-12 h-12 rounded-full bg-rose-100 flex items-center justify-center mx-auto mb-4">
//                             <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-rose-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//                                 <polyline points="3 6 5 6 21 6" />
//                                 <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
//                                 <path d="M10 11v6M14 11v6" />
//                                 <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
//                             </svg>
//                         </div>
//                         <h3 className="text-base font-bold text-slate-800 text-center mb-1">Delete Beneficiary?</h3>
//                         <p className="text-slate-500 text-sm text-center mb-5">
//                             <span className="font-semibold text-slate-700">{beneficiaries[selectedCheckbox]?.beneficiaryName}</span> will be permanently removed.
//                         </p>
//                         <div className="flex gap-3">
//                             <button
//                                 onClick={handleCancelDelete}
//                                 className="flex-1 py-2.5 rounded-xl bg-slate-100 text-slate-700 text-sm font-semibold hover:bg-slate-200 transition"
//                             >
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleDeleteBeneficiary}
//                                 disabled={deleteLoading}
//                                 className="flex-1 py-2.5 rounded-xl bg-rose-500 text-white text-sm font-semibold hover:bg-rose-600 transition disabled:opacity-60"
//                             >
//                                 {deleteLoading ? "Deleting…" : "Delete"}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             )}
//         </>
//     );
// };

// export default Settlement2Remitter; 



import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useApi from "../../../CustomHooks/useApi";
import { useSelector } from "react-redux";

const Settlement2Remitter = () => {
    const location = useLocation();
    const remitter_mobile = location.state?.mobile;

    const onetimelimit = useSelector((store) => store?.auth?.employeeDetails?.oneTimeLimit);
    const navigate = useNavigate();

    const username = useSelector((state) => state.auth.employeeDetails?.username);

    const [beneficiaries, setBeneficiaries] = useState([]);
    const [beneid, setBeniId] = useState("");
    const [selectedModes, setSelectedModes] = useState({});
    const [amounts, setAmounts] = useState({});
    const [error, setError] = useState("");
    const [selectedRows, setSelectedRows] = useState([]);
    const [selectedCheckbox, setSelectedCheckbox] = useState(null);
    const [loading, setLoading] = useState(false);
    const [showDeletePopup, setShowDeletePopup] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [customerDetails, setCustomerDetails] = useState(null);

    const [searchQuery, setSearchQuery] = useState("");

    const { callApi: fetchBeneIMPS1 } = useApi("/dmt/list/beneficiary", "GET");
    const { callApi: fetchCustomerDetails } = useApi("/payout/customer/details", "GET");
    const { callApi: deletebene } = useApi("/dmt/delete/beneficiary", "PUT");

    useEffect(() => {
        if (remitter_mobile) {
            fetchBeneficiaries();
            getCustomerDetails();
        }
    }, [remitter_mobile]);

    const hasValidAmount = (index) => {
        const val = amounts[index];
        return val && Number(val) >= 1000;
    };

    useEffect(() => {
        if (beneficiaries.length > 0) {
            const defaultModes = {};
            beneficiaries.forEach((_, index) => {
                defaultModes[index] = "IMPS";
            });
            setSelectedModes(defaultModes);
        }
    }, [beneficiaries]);

    const getCustomerDetails = async () => {
        try {
            const res = await fetchCustomerDetails(null, `?mobile=${remitter_mobile}`);
            setCustomerDetails(res);
        } catch (err) {
            console.error("CUSTOMER DETAILS ERROR", err);
        }
    };

    const handleCheckboxChange = (index) => {
        setError("");

        if (index === selectedCheckbox) {
            setSelectedCheckbox(null);
            setAmounts((prev) => ({ ...prev, [index]: "" }));
            setSelectedModes((prev) => ({ ...prev, [index]: "" }));
            setSelectedRows([]);
            return;
        }

        setSelectedCheckbox(index);
        setSelectedModes((prev) => ({ ...prev, [index]: "IMPS" }));
        setSelectedRows([
            {
                index,
                ...beneficiaries[index],
                amount: amounts[index] || "",
                mode: "IMPS",
            },
        ]);
    };

    const handleDeleteBeneficiary = async () => {
        if (selectedCheckbox === null) return;

        setDeleteLoading(true);
        setError("");

        try {
            const selectedBeneficiary = beneficiaries[selectedCheckbox];

            const response = await deletebene(
                null,
                `?beneficiary_id=${selectedBeneficiary.bene_id || selectedBeneficiary.beneficiaryId}&remitter_mobile=${remitter_mobile}&username=${username}`
            );

            console.log("DELETE RESPONSE", response);

            if (response && response.status !== "FAILED") {
                setSelectedCheckbox(null);
                setSelectedRows([]);
                setAmounts({});
                setSelectedModes({});
                setShowDeletePopup(false);
                await fetchBeneficiaries();
            } else {
                throw new Error("Delete failed");
            }
        } catch (error) {
            console.error("Delete beneficiary failed:", error);
            setError("Something went wrong while deleting. Please try again.");
        } finally {
            setDeleteLoading(false);
        }
    };

    const handleDeleteClick = (beniid) => {
        if (selectedCheckbox !== null) {
            setBeniId(beniid);
            setShowDeletePopup(true);
        }
    };

    const handleCancelDelete = () => {
        setShowDeletePopup(false);
    };

    const handleModeChange = (index, mode) => {
        setSelectedModes((prev) => {
            const updatedModes = { ...prev, [index]: mode };
            if (index === selectedCheckbox) {
                setSelectedRows([
                    {
                        index,
                        ...beneficiaries[index],
                        amount: amounts[index] || "",
                        mode: mode,
                    },
                ]);
            }
            return updatedModes;
        });
    };

    const handleAmountChange = (index, value) => {
        if (parseFloat(value) < 1000) {
            setError("Please enter an amount greater than or equal to 1000.");
        } else {
            setError("");
        }

        if (parseFloat(value) > onetimelimit) {
            setError(`Please enter an amount less than or equal to ${onetimelimit}`);
        } else {
            setError("");
        }

        setAmounts((prev) => {
            const updatedAmounts = { ...prev, [index]: value };
            if (index === selectedCheckbox) {
                setSelectedRows([
                    {
                        index,
                        ...beneficiaries[index],
                        amount: value,
                        mode: selectedModes[index] || "",
                    },
                ]);
            }
            return updatedAmounts;
        });
    };

    const fetchBeneficiaries = async () => {
        setLoading(true);
        try {
            const response = await fetchBeneIMPS1(null, `?remitter_mobile=${remitter_mobile}`);
            setBeneficiaries(Array.isArray(response) ? response : []);
        } catch (error) {
            console.error("Fetch beneficiaries failed:", error);
            setBeneficiaries([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAddNewClick = () => {
        navigate("/add-beneficiary-imps2", {
            state: {
                mobile: customerDetails.mobile,
                name: customerDetails.name,
            },
        });
    };

    const handleProcess = async () => {
        if (selectedCheckbox === null) {
            setError("Please select a beneficiary first!");
            return;
        }

        const selectedMode = selectedModes[selectedCheckbox];
        const selectedAmount = amounts[selectedCheckbox];

        if (!selectedAmount) {
            setError("Please enter an amount before proceeding.");
            return;
        }

        if (parseFloat(selectedAmount) > onetimelimit) {
            setError(`Please enter an amount less than or equal to ${onetimelimit}`);
            return;
        }
        if (parseFloat(selectedAmount) < 1000) {
            setError("Amount must be at least 1000.");
            return;
        }

        if (!selectedMode) {
            setError("Please select a mode before proceeding.");
            return;
        }

        setError("");
        navigate("/settlement1fundtransfer", {
            state: {
                selectedBeneficiary: selectedRows.map(row => ({
                    ...row,
                    bene_id: row.bene_id,
                })),
                amount: selectedAmount,
            },
        });
    };

    const getStatusClasses = (status) => {
        switch (status) {
            case "APPROVED": return "bg-green-100 text-green-600";
            case "Failed":   return "bg-red-100 text-red-600";
            case "Pending":  return "bg-yellow-100 text-yellow-600";
            default:         return "";
        }
    };

    const filteredList = beneficiaries
        .map((item, index) => ({ ...item, _originalIndex: index }))
        .filter((item) => {
            if (!searchQuery.trim()) return true;
            const q = searchQuery.toLowerCase();
            return (
                (item.beneficiaryName || "").toLowerCase().includes(q) ||
                (item.bankName || "").toLowerCase().includes(q) ||
                (item.accountNo || "").toLowerCase().includes(q)
            );
        });

    return (
        <>
            <div className="max-w-[100%] mx-auto space-y-4">

                {/* ===== HEADER ===== */}
                <div className="flex flex-wrap items-center justify-between gap-3 bg-white rounded-2xl px-4 sm:px-6 py-4 shadow-sm border border-slate-200">
                    <div className="flex items-center gap-3">
                        <div className="w-10 h-10 2xl:w-12 2xl:h-12 min-[2000px]:w-16 min-[2000px]:h-16 rounded-full bg-[#12345A] flex items-center justify-center text-white font-bold text-sm 2xl:text-base min-[2000px]:text-[22px] shrink-0">
                            {customerDetails?.name?.[0]?.toUpperCase() || "?"}
                        </div>
                        <div>
                            <p className="font-bold text-slate-800 text-base 2xl:text-lg min-[2000px]:text-[24px] leading-tight">
                                {customerDetails?.name || "—"}
                            </p>
                            <p className="text-indigo-600 text-sm 2xl:text-base min-[2000px]:text-[20px] font-medium">
                                {customerDetails?.mobile || "—"}
                            </p>
                        </div>
                    </div>

                    <div className="flex flex-wrap items-center gap-3">
                        <div className="relative">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 2xl:w-5 2xl:h-5 min-[2000px]:w-7 min-[2000px]:h-7 text-slate-400 pointer-events-none"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                            >
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.35-4.35" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Search name, bank, account…"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="pl-9 pr-8 py-2 text-sm 2xl:text-base min-[2000px]:text-[20px] border border-slate-200 rounded-xl bg-slate-50 focus:outline-none focus:border-[#12345A] focus:ring-2 focus:ring-[#12345A]/10 transition w-52 sm:w-64 2xl:w-72 min-[2000px]:w-96"
                            />
                            {searchQuery && (
                                <button
                                    onClick={() => setSearchQuery("")}
                                    className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700 text-lg 2xl:text-xl min-[2000px]:text-3xl leading-none transition"
                                    title="Clear search"
                                >
                                    ×
                                </button>
                            )}
                        </div>

                        <button
                            onClick={handleAddNewClick}
                            className="px-4 py-2 text-sm 2xl:text-base min-[2000px]:text-[20px] font-semibold bg-[#12345A] hover:bg-[#0F2E47] text-white rounded-xl shadow transition whitespace-nowrap"
                        >
                            + Add Beneficiary
                        </button>
                    </div>
                </div>

                {/* ===== ERROR ===== */}
                {error && (
                    <div className="bg-rose-50 border border-rose-200 text-rose-700 text-sm 2xl:text-base min-[2000px]:text-[20px] px-4 py-3 rounded-xl">
                        {error}
                    </div>
                )}

                {/* ===== TABLE ===== */}
                {loading ? (
                    <div className="bg-white rounded-2xl p-10 text-center text-slate-500 text-sm 2xl:text-base min-[2000px]:text-[20px] shadow-sm border border-slate-200">
                        Loading beneficiaries…
                    </div>
                ) : beneficiaries.length === 0 ? (
                    <div className="bg-white rounded-2xl p-10 text-center text-slate-500 text-sm 2xl:text-base min-[2000px]:text-[20px] shadow-sm border border-slate-200">
                        No beneficiaries found
                    </div>
                ) : (
                    <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
                        {searchQuery.trim() && (
                            <div className="px-4 py-2 text-xs 2xl:text-sm min-[2000px]:text-[16px] text-slate-500 bg-slate-50 border-b border-slate-100">
                                {filteredList.length} of {beneficiaries.length} beneficiar{beneficiaries.length === 1 ? "y" : "ies"} match "<span className="font-semibold text-slate-700">{searchQuery}</span>"
                            </div>
                        )}

                        <div className="overflow-x-auto">
                            {/* ▼▼▼ STEPPED FONT SIZE BASE ▼▼▼ */}
                            <table className="w-full text-sm 2xl:text-base min-[2000px]:text-[22px] border-collapse">
                                <thead className="bg-slate-100 text-slate-600 text-xs 2xl:text-sm min-[2000px]:text-[18px] uppercase tracking-wide">
                                    <tr>
                                        <th className="px-3 py-3 text-center w-12 2xl:w-16 min-[2000px]:w-24 border border-slate-200">Select</th>
                                        <th className="px-4 py-3 text-left border border-slate-200">Beneficiary</th>
                                        <th className="px-4 py-3 text-left border border-slate-200">Bank</th>
                                        <th className="px-4 py-3 text-left border border-slate-200">Account No</th>
                                        <th className="px-4 py-3 text-left border border-slate-200">IFSC</th>
                                        <th className="px-4 py-3 text-left border border-slate-200" style={{ minWidth: 200 }}>Amount (₹)</th>
                                        <th className="px-4 py-3 text-center border border-slate-200" style={{ minWidth: 140 }}>Actions</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {filteredList.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="py-12 text-center text-slate-400 border border-slate-200">
                                                No results for "<span className="font-semibold">{searchQuery}</span>"
                                            </td>
                                        </tr>
                                    ) : (
                                        filteredList.map((item) => {
                                            const index = item._originalIndex;
                                            const isSelected = selectedCheckbox === index;
                                            const canTransfer = isSelected && hasValidAmount(index);

                                            return (
                                                <tr
                                                    key={index}
                                                    onClick={() => handleCheckboxChange(index)}
                                                    className={`cursor-pointer transition-colors ${
                                                        isSelected ? "bg-blue-50/60" : "hover:bg-slate-50"
                                                    }`}
                                                >
                                                    {/* Select */}
                                                    <td className="px-3 py-4 text-center border border-slate-200" onClick={(e) => e.stopPropagation()}>
                                                        <input
                                                            type="checkbox"
                                                            checked={isSelected}
                                                            onChange={() => handleCheckboxChange(index)}
                                                            className="w-4 h-4 2xl:w-5 2xl:h-5 min-[2000px]:w-7 min-[2000px]:h-7 cursor-pointer accent-[#12345A]"
                                                        />
                                                    </td>

                                                    {/* Beneficiary Name + Status */}
                                                    <td className="px-4 py-4 border border-slate-200">
                                                        <p className={`font-bold leading-snug ${isSelected ? "text-[#12345A]" : "text-slate-800"}`}>
                                                            {item.beneficiaryName}
                                                        </p>
                                                        <span className={`inline-block mt-1 px-2 py-0.5 rounded-full font-semibold text-[10px] 2xl:text-xs min-[2000px]:text-[14px] ${
                                                            item.verificationStatus === "APPROVED"
                                                                ? "bg-emerald-100 text-emerald-700"
                                                                : item.verificationStatus === "Pending"
                                                                    ? "bg-amber-100 text-amber-700"
                                                                    : "bg-rose-100 text-rose-700"
                                                        }`}>
                                                            {item.verificationStatus}
                                                        </span>
                                                    </td>

                                                    {/* Bank */}
                                                    <td className="px-4 py-4 border border-slate-200">
                                                        <p className="text-slate-600">{item.bankName}</p>
                                                        <span className="inline-block mt-1 px-1.5 py-0.5 rounded-full font-bold bg-indigo-100 text-indigo-700 tracking-wide text-[10px] 2xl:text-xs min-[2000px]:text-[14px]">
                                                            IMPS
                                                        </span>
                                                    </td>

                                                    {/* Account No */}
                                                    <td className="px-4 py-4 border border-slate-200 font-bold text-red-600 font-mono">
                                                        {item.accountNo}
                                                    </td>

                                                    {/* IFSC */}
                                                    <td className="px-4 py-4 border border-slate-200 font-black text-slate-900 font-mono">
                                                        {item.ifscCode}
                                                    </td>

                                                    {/* Amount Input */}
                                                    <td className="px-4 py-4 border border-slate-200" onClick={(e) => e.stopPropagation()}>
                                                        <input
                                                            type="text"
                                                            inputMode="numeric"
                                                            placeholder="Min ₹1,001"
                                                            value={amounts[index] || ""}
                                                            disabled={!isSelected}
                                                            onChange={(e) => {
                                                                const val = e.target.value;
                                                                if (/^\d{0,6}$/.test(val)) handleAmountChange(index, val);
                                                            }}
                                                            onKeyDown={(e) => {
                                                                if (e.key === "Enter" && canTransfer) handleProcess();
                                                            }}
                                                            className={`w-full px-3 py-2.5 rounded-xl border font-semibold outline-none transition ${
                                                                isSelected
                                                                    ? "border-[#12345A] bg-white text-slate-800 focus:ring-2 focus:ring-[#12345A]/20"
                                                                    : "border-slate-200 bg-slate-50 text-slate-400 cursor-not-allowed"
                                                            }`}
                                                        />
                                                    </td>

                                                    {/* Actions */}
                                                    <td className="px-4 py-4 border border-slate-200" onClick={(e) => e.stopPropagation()}>
                                                        <div className="flex items-center justify-center gap-2">
                                                            <button
                                                                onClick={handleProcess}
                                                                disabled={!canTransfer}
                                                                title="Fund Transfer"
                                                                className={`flex items-center gap-1.5 px-3 py-2 rounded-xl font-bold transition whitespace-nowrap text-xs 2xl:text-sm min-[2000px]:text-[18px] ${
                                                                    canTransfer
                                                                        ? "bg-[#12345A] text-white shadow-sm hover:bg-[#0F2E47]"
                                                                        : "bg-slate-100 text-slate-400 cursor-not-allowed"
                                                                }`}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-3.5 h-3.5 2xl:w-4 2xl:h-4 min-[2000px]:w-5 min-[2000px]:h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                                                                    <path d="M5 12h14M12 5l7 7-7 7" />
                                                                </svg>
                                                                Transfer
                                                            </button>

                                                            <button
                                                                onClick={() => handleDeleteClick(item.bene_id || item.beneficiaryId)}
                                                                disabled={!isSelected}
                                                                title="Delete Beneficiary"
                                                                className={`flex items-center justify-center w-9 h-9 2xl:w-10 2xl:h-10 min-[2000px]:w-14 min-[2000px]:h-14 rounded-xl transition ${
                                                                    isSelected
                                                                        ? "bg-rose-50 text-rose-600 hover:bg-rose-100 border border-rose-200"
                                                                        : "bg-slate-100 text-slate-300 cursor-not-allowed border border-slate-200"
                                                                }`}
                                                            >
                                                                <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 2xl:w-5 2xl:h-5 min-[2000px]:w-6 min-[2000px]:h-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                                                    <polyline points="3 6 5 6 21 6" />
                                                                    <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                                                    <path d="M10 11v6M14 11v6" />
                                                                    <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>

            {/* ===== DELETE CONFIRMATION POPUP ===== */}
            {showDeletePopup && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl p-6 w-full max-w-sm 2xl:max-w-md min-[2000px]:max-w-2xl shadow-xl">
                        <div className="w-12 h-12 2xl:w-14 2xl:h-14 min-[2000px]:w-20 min-[2000px]:h-20 rounded-full bg-rose-100 flex items-center justify-center mx-auto mb-4">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 2xl:w-7 2xl:h-7 min-[2000px]:w-10 min-[2000px]:h-10 text-rose-600" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <polyline points="3 6 5 6 21 6" />
                                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                                <path d="M10 11v6M14 11v6" />
                                <path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" />
                            </svg>
                        </div>
                        <h3 className="font-bold text-slate-800 text-center mb-1 text-base 2xl:text-lg min-[2000px]:text-[24px]">
                            Delete Beneficiary?
                        </h3>
                        <p className="text-slate-500 text-center mb-5 text-sm 2xl:text-base min-[2000px]:text-[20px]">
                            <span className="font-semibold text-slate-700">{beneficiaries[selectedCheckbox]?.beneficiaryName}</span> will be permanently removed.
                        </p>
                        <div className="flex gap-3">
                            <button
                                onClick={handleCancelDelete}
                                className="flex-1 py-2.5 rounded-xl bg-slate-100 text-slate-700 font-semibold hover:bg-slate-200 transition text-sm 2xl:text-base min-[2000px]:text-[20px]"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={handleDeleteBeneficiary}
                                disabled={deleteLoading}
                                className="flex-1 py-2.5 rounded-xl bg-rose-500 text-white font-semibold hover:bg-rose-600 transition disabled:opacity-60 text-sm 2xl:text-base min-[2000px]:text-[20px]"
                            >
                                {deleteLoading ? "Deleting…" : "Delete"}
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default Settlement2Remitter;